import { ServiceArticlePage } from "@/components/ServiceArticlePage";
import { SERVICES } from "@/data/content";
import { SOFTWARE_DEVELOPMENT_ARTICLE } from "@/data/softwareDevelopment";

const service = SERVICES.find((s) => s.slug === "software-development");

export default function SoftwareDevelopment() {
  return (
    <ServiceArticlePage
      service={service}
      blocks={SOFTWARE_DEVELOPMENT_ARTICLE}
      overline="Service guide — II"
      lede="Custom business applications, client portals, dashboards, system integrations and APIs — built to your written requirements, delivered in stages, and maintained under a monthly retainer if required."
      seoDescription="Custom software development from My Geeks LLC: business applications, client portals, dashboards, integrations and APIs for companies. Scoped in writing, billed by milestone. Request a quote."
    />
  );
}
